import * as React from 'react';
import './header.css';

export const headerHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="s-header-habitat">{children}</div>;
};
